$(document).ready(function () {
  let p = $('body').attr('p');

  if (
    p === 'order_confirmation' ||
    p === 'today_orders' ||
    p == 'organizer_gift_cards'
  ) {
    $(document).on('submit', '#receipt-in-email', function () {
      $('.alert').remove();
      const submitButton = $(this).find('button[type=submit]');
      const buttonText = submitButton.text();

      submitButton
        .prop('disabled', true)
        .empty()
        .html('<div class="loader"></div>');

      $.ajax({
        type: 'POST',
        url: '/ajax/order/send_receipt_in_email',
        data: {
          serialized_post: $(this).serialize(),
        },
      })
        .done(function (data) {
          if (data.html !== undefined && data.html !== null) {
            popupAlert();

            submitButton.prop('disabled', false).text(buttonText);
            $('#emailReceiptModal').modal('hide');
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }

          if (
            data.responseJSON.error_message !== undefined &&
            data.responseJSON.error_message !== null
          ) {
            prependAlert(
              '#receipt-in-email-button-wrapper',
              data.responseJSON.error_message,
              'danger',
              null,
              '#receipt-in-email'
            );
          }
          submitButton.prop('disabled', false).text(buttonText);
        });

      return false;
    });

    $(document).on('submit', '#sendOrdergiftCardEmail', function (e) {
      e.preventDefault();
      $('.alert').remove();
      const formData = new FormData(e.target);

      const submitButton = $('#resend-gift-card-email');
      const originalText = submitButton.data('original-text');
      const loadingText = submitButton.data('loading-text');

      // Disable button and show loading
      submitButton.prop('disabled', true).html(loadingText);

      $.ajax({
        type: 'POST',
        url: '/api/v1/gift-card/send-email',
        data: formData,
        enctype: 'multipart/form-data',
        async: true,
        cache: false,
        processData: false,
        contentType: false,
      })
        .done(function (response) {
          const { data, message, status } = response;
          if (message !== undefined && message !== null) {
            showToast({
              type: 'success',
              message: message,
              position: 'top-right',
              duration: 4000,
            });
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }

          if (
            data.responseJSON.message !== undefined &&
            data.responseJSON.message !== null
          ) {
            showToast({
              type: 'error',
              message: data.responseJSON.message,
              position: 'top-right',
              duration: 4000,
            });
          }
        })
        .always(function () {
          submitButton.prop('disabled', false).html(originalText);
        });
    });

    $(document).on('click', '.print-order', function () {
      const location_id = $(this).data('location-id');
      const orderIds = $(this).attr('data-order-ids');

      if (isOnDevice) {
        const printDocument = $(this).data('print-document');
        const printSegments = $(this).data('pax-print-segments');
        passTerminalDataToWebView({
          action: $('body').attr('is_verifone') == 1 ? 'verifone' : 'pax',
          data: {
            action: 'print',
            data: {
              document: printDocument,
              segments: printSegments,
              contentTypeString: 'HTML',
              receiptTypeString: 'DOCUMENT',
              deliveryMethodString: 'PRINT',
              deliveryAddress: '',
            },
          },
        });
        return;
      }

      $.ajax({
        type: 'POST',
        url: '/ajax/printer/get_printer_list_modal',
        data: { location_id, order_ids: orderIds },
      })
        .done(function (data) {
          if (data.html !== undefined && data.html !== null) {
            $('#printer-list-modal').remove();
            $('#content').append(data.html);
            checkTerminalAvailability('print');
            $('#printer-list-modal')
              .on('shown.bs.modal', function () {
                fixBackdrops();
              })
              .on('hidden.bs.modal', function () {
                restoreBackdrops();
                setTimeout(function () {
                  $('#printer-list-modal').remove();
                }, 500);
              })
              .modal('show');
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        });
    });
  }

  $(document).on('click', '.terminal-print', function (e) {
    e.preventDefault();

    const location_id = $(this).data('location-id');
    const ip = $(this).data('printer-ip');
    const orderIds = $(this).attr('data-order-ids');

    let data = {};
    let action = $(this).attr('data-receipt-type') ?? null;
    if (action == 'advance_receipt' || action == 'supply_list') {
      const orderData = $(this).attr('data-order-data');

      data = {
        location_id,
        order_data: orderData,
        terminal_id: ip,
        action,
      };
    } else {
      data = {
        location_id,
        order_ids: orderIds,
        terminal_id: ip,
        action: 'print_order',
      };
    }

    $.ajax({
      type: 'POST',
      url: '/api/v1/private/printer/terminal-print',
      data: data,
    })
      .done(function (data) {})
      .fail(function (data) {
        if (
          data.responseJSON.redirect_url !== undefined &&
          data.responseJSON.redirect_url !== null
        ) {
          document.location.href = data.responseJSON.redirect_url;
        }

        if (
          data.responseJSON.error.message !== undefined &&
          data.responseJSON.error.message !== null
        ) {
          showToast({
            type: 'error',
            title: 'Error',
            message: data.responseJSON.error.message,
            position: 'top-right',
            duration: 4000,
          });
        }
      });
  });
});

function passDataToWebView(
  event,
  action,
  data,
  ip = '',
  type = '',
  organizer,
  order,
  deviceId = null,
  tableNumber = '',
  personName = ''
) {
  event?.preventDefault();

  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        action,
        data,
        ip,
        type,
        organizer,
        order,
        deviceId,
        tableNumber,
        personName,
      })
    );
  }
}
